import type { StepperStep } from '@wix/design-system/dist/types/Stepper';
import { useState } from 'react';

interface StepperState {
  steps: StepperStep[];
  activeStep: number;
}
const getStepType = (activeStep: number, stepIndex: number) =>
  stepIndex < activeStep ? 'completed' : 'disabled';

const initialStepIndex = 0;

export const useStepper = (initialStepsLabels: string[]) => {
  const [stepperState, setStepperState] = useState<StepperState>({
    steps: initialStepsLabels.map((stepLabel, index) => ({
      text: stepLabel,
      type: getStepType(initialStepIndex, index),
    })),
    activeStep: initialStepIndex,
  });

  const moveStepBy = (steps: number) =>
    setStepperState((prevState) => {
      const newActiveStep = prevState.activeStep + steps;
      return {
        steps: prevState.steps.map((step, index) => ({
          ...step,
          type: getStepType(newActiveStep, index),
        })),
        activeStep: newActiveStep,
      };
    });
  const onNextStep = () => moveStepBy(1);
  const onPrevStep = () => moveStepBy(-1);
  return { ...stepperState, onNextStep, onPrevStep };
};
